import { militaryMessages } from './en-US';

export const programId = '5d7197ce525dc71fee5d0579';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    messagesWithLocale: {
        'en-US': militaryMessages,
    },
};
